import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import Select from "react-select";
import Header from "./Header";
import Sidebar from "./Sidebar";
import Footer from "./Footer";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const Edit_ZM_Conveyance = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [visit, setVisit] = useState(null);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState("");
  const [branches, setBranches] = useState([]); // All branch options
  const [selectedBranches, setSelectedBranches] = useState([]); // Selected branch options

  /* ================= FETCH CONVEYANCE MASTER ================= */
  useEffect(() => {
    const fetchMaster = async () => {
      try {
        const token = localStorage.getItem("authToken");
        const res = await fetch(`${API_BASE_URL}getmasterdetails/${id}`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const result = await res.json();

        if (result.status && result.data.status === "success") {
          const master = result.data.data[0];
          setVisit(master);

          // Convert branch string to Select options
          if (master.branches) {
            const branchArr = master.branches.split(",").map(b => b.trim());
            setSelectedBranches(branchArr.map(b => ({ value: b, label: b })));
          }
        } else {
          setMessage("Conveyance master not found");
        }
      } catch (err) {
        console.error(err);
        setMessage("Failed to load conveyance master details");
      } finally {
        setLoading(false);
      }
    };

    fetchMaster();
  }, [id]);

  /* ================= FETCH ALL BRANCHES ================= */
  useEffect(() => {
    const fetchBranches = async () => {
      try {
        const token = localStorage.getItem("authToken");
        const res = await fetch(`${API_BASE_URL}getBranches`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const result = await res.json();
        if (result.status) {
          const options = result.data.map(branch => ({
            value: branch.SysNo,
            label: branch.SysField
          }));
          setBranches(options);
        }
      } catch (err) {
        console.error("Failed to fetch branches", err);
      }
    };
    fetchBranches();
  }, []);

  /* ================= INPUT CHANGE ================= */
  const handleChange = (field, value) => {
    setVisit({ ...visit, [field]: value });
  };

  /* ================= BRANCH CHANGE ================= */
  const handleBranchChange = (selected) => {
    setSelectedBranches(selected);
  };

  /* ================= UPDATE MASTER ================= */
  const handleUpdate = async () => {
    if (!visit.role || !visit.duration_type || !visit.amount) {
      alert("Please fill all required fields");
      return;
    }

    // Prepare payload
    const payload = {
      role: visit.role,
      emp_code: visit.emp_code,
      duration_type: visit.duration_type,
      '1_30_cnt': visit['1_30_cnt'], 
      amount: visit.amount,
      branches: selectedBranches.map(b => b.value).join(","), // Send as CSV
    };

    try {
      const token = localStorage.getItem("authToken");
      const res = await fetch(`${API_BASE_URL}update_conveyance_master/${id}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });

      const result = await res.json();
      if (result.status) {
        alert("✅ Conveyance master updated successfully");
        navigate("/manage_cmzmconveyance");
      } else {
        alert(result.message || "Update failed");
      }
    } catch (err) {
      console.error(err);
      alert("Server error");
    }
  };

  if (loading) return <h3 style={{ padding: 20 }}>Loading...</h3>;
  if (!visit) return <h3 style={{ padding: 20 }}>{message}</h3>;

  return (
    <div className="hold-transition sidebar-mini layout-fixed">
      <div className="wrapper">
        <Header />
        <Sidebar />

        <div className="content-wrapper" style={{ padding: "25px" }}>
          <h3 style={{ marginBottom: "15px", color: "#5a8dee" }}>
            ✏️ Edit ZM / CM Conveyance Master
          </h3>

          <div
            style={{
              background: "#fff",
              padding: "25px",
              borderRadius: "10px",
              maxWidth: "700px",
              boxShadow: "0 4px 14px rgba(0,0,0,0.08)",
            }}
          >
            {/* BASIC INFO */}
            <div style={{ marginBottom: "20px", fontSize: "14px" }}>
              <p><b>Employee Code:</b> {visit.emp_code}</p>
            </div>

            {/* ROLE */}
            <div style={{ marginBottom: "12px" }}>
              <label className="form-label">Role</label>
              <input
                type="text"
                className="form-control"
                value={visit.role}
                disabled
                onChange={(e) => handleChange("role", e.target.value)}
              />
            </div>

            {/* DURATION TYPE */}
            <div style={{ marginBottom: "12px" }}>
              <label className="form-label">Duration Type</label>
              <input
                type="number"
                className="form-control"
                value={visit.duration_type}
                disabled
                onChange={(e) => handleChange("duration_type", e.target.value)}
              />
            </div>

            {/* BRANCHES (EDITABLE) */}
            <div style={{ marginBottom: "12px" }}>
              <label className="form-label">Branches</label>
              <Select
                isMulti
                options={branches}
                value={selectedBranches}
                onChange={handleBranchChange}
                placeholder="Select Branches"
              />
            </div>

            
            <div style={{ marginBottom: "12px" }}>
  <label className="form-label">Number of Visits (1-30 days)</label>
  <input
    type="number"
    className="form-control"
    value={visit['1_30_cnt']}
    onChange={(e) => handleChange('1_30_cnt', e.target.value)} 
  />
</div>

            {/* AMOUNT */}
            <div style={{ marginBottom: "18px" }}>
              <label className="form-label">Amount</label>
              <input
                type="number"
                className="form-control"
                value={visit.amount}
                onChange={(e) => handleChange("amount", e.target.value)}
              />
            </div>

            {/* BUTTON */}
            <button
              onClick={handleUpdate}
              style={{
                padding: "10px 35px",
                background: "linear-gradient(135deg,#5a8dee,#6ca0dc)",
                color: "#fff",
                border: "none",
                borderRadius: "8px",
                fontWeight: "700",
                cursor: "pointer",
              }}
            >
              Update Conveyance Master
            </button>
          </div>
        </div>

        <Footer />
      </div>
    </div>
  );
};

export default Edit_ZM_Conveyance;
